<template>
  <div class="container-comments">
    <app-timeline>
      <app-timeline-item
        v-for="(comment, index) in comments" :key="index"
        variant="primary"
      >
        <div
          class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
        >
          <h6 class="mb-0">{{ comment.comentario }}</h6>
          <small class="text-muted">{{ comment.fecha | dateFormatTime }}</small>
        </div>
        <p class="mb-2">
          {{ comment.nombre }}
        </p>
        <div class="d-flex flex-sm-row flex-column justify-content-between align-items-start">
          <div class="mb-1 mb-sm-0" v-if="comment.documentos">
            <div class="d-flex mr-1 color-primary">
              <DownloadFile
                :mood="'compact'"
                v-for="(attachment, index) in comment.documentos"
                :key="index"
                :path="attachment.adjuntoUrl"
                :name="attachment.nombre"
                :version-id="attachment.versionId"
                class="pill-info-attach"
                v-b-tooltip.hover.right="`${attachment.nombre}`"
              />
            </div>
          </div>
        </div>
      </app-timeline-item>
    </app-timeline>
  </div>
</template>
<script>

import DownloadFile from '@/febos/chile/dnt/components/DownloadFile';
import AppTimeline from '@core/components/app-timeline/AppTimeline';
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem';

export default {
  components: {
    AppTimeline,
    AppTimelineItem,
    DownloadFile
  },
  data() {
    return {
      commentary: ''
    };
  },
  computed: {},
  props: {
    comments: {
      type: Array,
      required: true
    }
  }
};
</script>
<style>
.container-comments {
  height: 250px;
  overflow-y: scroll;
}

</style>
